import axios from "axios";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export const getExportables = async (
  flagUpdateFunction,
  reportFilters,
  aditionalFilter,
  addNotification
) => {
  //flagUpdateFunction((prev) => ({ ...prev, loadingExportables: true }));
  try {
    const defaultRetailers = JSON.parse(
      sessionStorage.getItem("company")
    ).retailers.map((retailer) => retailer.id);

    const email = encodeURIComponent(
      JSON.parse(sessionStorage.getItem("user")).email
    );
    let reportFiltersCopy = reportFilters ?? {
      filterByRetailer: defaultRetailers,
    };
    if (!reportFiltersCopy.filterByRetailer) {
      reportFiltersCopy.filterByRetailer = defaultRetailers;
    }
    const filtersForQuery = encodeURIComponent(JSON.stringify(reportFilters));
    //   const jsFilter = aditionalFilter
    //     ? `&jsFilter=${encodeURIComponent(JSON.stringify(aditionalFilter))}`
    //     : "";
    // ${process.env.REACT_APP_REPORTS}?email=${email}&filters=${filtersForQuery}&reportType=2${jsFilter}`,
    const response = await axios.get(
      `${process.env.REACT_APP_REPORTS}?email=${email}&filters=${filtersForQuery}&reportType=2`,
      {
        headers: {
          Authorization: sessionStorage.getItem("jwt"),
        },
      }
    );
    saveAs(JSON.parse(response.data.body).url);
    addNotification("success", "El reporte ha sido enviado a su correo");
  } catch (error) {
    console.log(error);
    addNotification("error", "Error al enviar reporte");
  }
  flagUpdateFunction((prev) => ({ ...prev, loadingExportables: false }));
};

export const getExportablesProvider = async (
  setLoadingExportables,
  addNotification
) => {
  setLoadingExportables(true);
  try {
    const response = await axios.get(`${process.env.REACT_APP_EXPORTABLES}`, {
      headers: {
        Authorization: sessionStorage.getItem("jwt"),
      },
    });
    saveAs(JSON.parse(response.data.body).url);
    addNotification("success", "El reporte ha descargado correctamente");
    setLoadingExportables(false);
  } catch (error) {
    console.log(error);
    addNotification("error", "Error al descargar reporte");
  }
};

export const readExcel = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Primera hoja
      const sheet = workbook.Sheets[workbook.SheetNames[0]];

      // Convertir a JSON
      const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      // Extraer validaciones de datos (listas desplegables)
      const dataValidations = {};
      if (sheet["!dataValidation"]) {
        sheet["!dataValidation"].forEach((validation) => {
          if (validation.type === "list" && validation.sqref) {
            // sqref contiene las celdas que tienen validación (ej: "B6:B100")
            dataValidations[validation.sqref] = validation.formulae || [];
          }
        });
      }

      resolve({ json, dataValidations, sheet });
    };

    reader.onerror = (err) => reject(err);

    reader.readAsArrayBuffer(file);
  });
};

export const transformExcelToArticles = (excelData) => {
  const rows = excelData.json || excelData; // Soportar ambos formatos
  const dataValidations = excelData.dataValidations || {};
  const sheet = excelData.sheet;

  const idRow = rows[2];
  const typeRow = rows[3];
  const headerRow = rows[4];

  // Detectar columnas con listas desplegables
  const dropdownColumns = new Set();
  if (sheet && sheet["!dataValidation"]) {
    sheet["!dataValidation"].forEach((validation) => {
      if (validation.type === "list" && validation.sqref) {
        // Extraer la columna de sqref (ej: "B6:B100" -> columna B)
        const colLetter = validation.sqref.match(/^([A-Z]+)/)?.[1];
        if (colLetter) {
          // Convertir letra de columna a índice (A=0, B=1, etc)
          const colIndex = colLetter.split("").reduce((acc, char, idx) => {
            return (
              acc +
              (char.charCodeAt(0) - 65) *
                Math.pow(26, colLetter.length - idx - 1)
            );
          }, 0);
          dropdownColumns.add(colIndex);
        }
      }
    });
  }

  const articles = [];

  for (let i = 5; i < rows.length; i++) {
    const row = rows[i];
    if (!row || !row[0]) continue;

    const compositeId = row[0].toString();
    const [articleId, versionId, categoryId, retailers] =
      compositeId.split("-");

    const article = {
      articleId: parseInt(articleId),
      versionId: parseInt(versionId),
      categoryId: parseInt(categoryId),
      retailers: retailers.split("-").map((r) => ({ id: parseInt(r) })),
      attributes: [],
      descriptions: [],
    };

    for (let col = 1; col < row.length; col++) {
      const colId = idRow[col];
      const colType = typeRow[col];
      const colName = headerRow[col];
      const value = row[col];

      // Saltar solo si no hay colId o colName (columna inválida)
      if (colId == null || !colName) continue;

      const item = {
        id: parseInt(colId),
        name: colName,
        value: value ? value.toString().trim() : "",
      };

      if (colType === 1) article.descriptions.push(item);
      else article.attributes.push(item);
    }

    articles.push(article);
  }

  return articles;
};
